import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { CoreService } from "./core.service";
import { API } from "./paymentapiroutes";

@Injectable({
  providedIn: "root"
})
export class LoginService {
  constructor(
    private apiService: ApiService,
    private coreservice:CoreService
    ) 
    {
      
    }
   
  login(username: string, password: string,loginfrom:number) {
      return this.apiService.authpost(API.LOGIN, { username:username, password:password,login_from:loginfrom });
  }
  
  registration(user) {
    return this.apiService.authpost(API.REGISTRED,user);
}
  logout() {
      // remove user from local storage to log user out
      localStorage.removeItem('currentUser');
      this.coreservice.UserSub.next(null);
  }
}
